import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonUtil, MessageService, TablePage } from '@serengeti/serengeti-common';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class ProjectService {

	endPoint: string;
	activeState = true;
  
	constructor(private messageService: MessageService) {
		this.endPoint = CommonUtil.buildEndPoint(environment.serviceProjectEndPoint, 'service');
		this.activeState = environment.content && environment.content.disabled_service ? 
			!environment.content.disabled_service.includes('api.service') : true;
	}
  
	search(filter = '',
		sortItem = 'name', sortOrder = 'asc',
		pageNumber = 0, pageSize = 10): Observable<TablePage> {
  
		const url = CommonUtil.buildEndPoint(this.endPoint, '/');

		return this.messageService.query(url, new HttpParams()
			.set('keyword', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString()));
	}

	waiting(sortItem = 'createdDate', sortOrder = 'desc',
		pageNumber = 0, pageSize = 10): Observable<TablePage> {
  
		const url = CommonUtil.buildEndPoint(this.endPoint, '/waiting');

		return this.messageService.query(url, new HttpParams()
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString()));
	}

	activity(filter = '',
		sortItem = 'issuedDate', sortOrder = 'desc',
		pageNumber = 0, pageSize = 10): Observable<TablePage> {
  
		const url = CommonUtil.buildEndPoint(this.endPoint, '/activity');

		return this.messageService.query(url, new HttpParams()
			.set('keyword', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString()));
	}

	users(filter = '',
		sortItem = 'name', sortOrder = 'asc',
		pageNumber = 0, pageSize = 10): Observable<TablePage> {

		const url = CommonUtil.buildEndPoint(environment.serviceProjectEndPoint, 'user/');

		return this.messageService.query(url, new HttpParams()
			.set('keyword', filter)
			.set('sortItem', sortItem)
			.set('sortOrder', sortOrder)
			.set('pageNumber', pageNumber.toString())
			.set('pageSize', pageSize.toString()));
	}

	user(userId: string): Observable<any> {
		const url = CommonUtil.buildEndPoint(environment.serviceProjectEndPoint, 'user/' + userId + '/');

		return this.messageService.query(url);
	}

	types(): Observable<any> {
		const url = environment.serviceProjectEndPoint + 'type/list';

		return this.messageService.query(url);
	}

	get(id: string): Observable<any> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');

		return this.messageService.query(url);
	}
	
	save(id: string, project: any) {
		let url = CommonUtil.buildEndPoint(this.endPoint, '/');
	
		if (id) {
			url += id + '/';
			return this.messageService.put(url, project);
		} else {
			url += 'type/' + project.type.id + '/';
			return this.messageService.post(url, project);
		}
	}

	delete(id: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/');
	
		return this.messageService.delete(url);
	}

	inviteAll(id: string, userIds: string[]): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/invite');
	
		return this.messageService.patch(url, userIds);
	}

	invite(id: string, userId: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/' + userId + '/invite');
	
		return this.messageService.patch(url);
	}

	request(id: string, userId: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/' + userId + '/request');
	
		return this.messageService.patch(url);
	}

	withdraw(id: string, userId: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/' + userId + '/withdraw');
	
		return this.messageService.delete(url);
	}

	reject(id: string, userId: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/' + userId + '/reject');
	
		return this.messageService.delete(url);
	}

	approve(id: string, userId: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/' + userId + '/approve');
	
		return this.messageService.patch(url);
	}

	remove(id: string, userId: string): Observable<void> {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/user/' + userId + '/');
	
		return this.messageService.delete(url);
	}

	launch(id: string, catalog: any) {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/' + id + '/catalog/launch');
	
		return this.messageService.post(url, catalog);
	}
}
